// extracted by mini-css-extract-plugin
export default {"agreement":"styles_agreement__Z1aZu"};